module.exports = __webpack_public_path__ + "static/media/Screen Shot 2022-08-09 at 4.57a9b0ec.21";